import { LegalShell } from "./LegalShell";

const UPDATED = "April 23, 2026";

export default function TermsOfService() {
  return (
    <LegalShell title="Terms of Service" updated={UPDATED}>
      <p className="text-sm"><strong>Important:</strong> BallBoy (the “Service”, “we”, “us”, “our”) is an online marketplace that connects
      individuals seeking practice assistance (“Athletes”) with individuals offering such assistance (“Ball Boys”).
      <strong> BallBoy is NOT a party to any agreement between Athletes and Ball Boys, is not a sports coach,
      trainer, employer, agent, or insurer, and makes no representations or warranties about the skill, fitness,
      safety, or conduct of any User.</strong> By using the Service you acknowledge that athletic activities
      involve inherent and serious risks, including injury or death, and you assume those risks at your own
      discretion.</p>

      <h2>1. Acceptance &amp; Eligibility</h2>
      <p>By creating an account, accessing, or using the Service you agree to these Terms of Service and our
      Privacy Policy. If you do not agree, do not use the Service. You must be at least 18 years old and legally
      able to enter a binding contract. Users under 18 may only use the Service with the direct supervision and
      written consent of a parent or legal guardian who agrees to these Terms on their behalf.</p>

      <h2>2. Accounts &amp; Tiered Trust</h2>
      <p>You agree to provide accurate, current, and complete information, keep it updated, and safeguard your
      password. You are responsible for all activity on your account. BallBoy operates a tiered trust model
      (Basic, Verified, Mandatory ID) and may, at its sole discretion, require additional verification
      (including government ID and selfie match) before permitting certain bookings. BallBoy may suspend or
      terminate any account at any time, with or without notice, for any reason, including suspected fraud,
      abuse, or violation of these Terms.</p>

      <h2>3. The Service; Marketplace Role</h2>
      <p>The Service is a technology platform. BallBoy does not provide athletic training, coaching, or physical
      services, does not employ Ball Boys, and exercises no control over the manner or means by which Ball Boys
      perform services. Users contract directly with each other. Any dispute regarding the quality, safety, or
      legality of services rendered is between the Users involved.</p>

      <h2>4. User Conduct</h2>
      <p>You agree not to: (a) violate any law; (b) harass, threaten, defraud, or abuse any person; (c) upload
      false or misleading information, impersonate another person, or misrepresent credentials; (d) circumvent
      the Service to contact or pay Users off-platform; (e) use the Service for illegal activities including
      gambling, prohibited substances, or exploitation; (f) attempt to reverse engineer, scrape, or disrupt the
      Service. Violations may result in account termination and legal action.</p>

      <h2>5. Assumption of Risk &amp; Medical Clearance</h2>
      <p>You acknowledge that physical activity carries risk of serious injury or death, including without
      limitation sprains, fractures, concussions, cardiac events, heatstroke, and drowning. You represent that
      you are in good health and have obtained any medical clearance appropriate to your activity. You are
      solely responsible for choosing safe locations, equipment, and training partners.</p>

      <h2>6. RELEASE, WAIVER &amp; INDEMNIFICATION</h2>
      <p>To the fullest extent permitted by law, you release and forever discharge BallBoy, its officers,
      directors, employees, affiliates, and agents (“Released Parties”) from any and all claims, damages,
      losses, liabilities, and expenses (including attorneys’ fees) of any kind, whether known or unknown,
      arising out of or related to your use of the Service, any interaction with other Users, or any activity
      conducted in connection with a booking, including negligence of Released Parties to the maximum extent
      permitted by law. You agree to defend, indemnify and hold harmless the Released Parties from any claim
      brought by a third party arising from your acts or omissions, your content, or your violation of these
      Terms.</p>

      <h2>7. Payments, Fees &amp; Refunds</h2>
      <p>Payments are processed by PayPal. You authorize BallBoy to charge your selected payment method for the
      full amount due, including service fees, applicable taxes, and platform fees (currently 10%). Ball Boys
      receive earnings after platform fees and any deductions. <strong>All sales are final; refunds are
      discretionary.</strong> Chargebacks or disputed charges may result in immediate suspension. You agree to
      resolve payment disputes first via the Service’s internal process before contacting your card issuer or
      PayPal.</p>

      <h2>8. Cancellations &amp; No-Shows</h2>
      <p>Cancellations by Athletes within 2 hours of the booking start time may incur a fee of up to 50% of the
      session total. Ball Boy no-shows may result in a full refund to the Athlete and a penalty on the Ball
      Boy’s account. Repeated cancellations may reduce a User’s trust level.</p>

      <h2>9. Background &amp; ID Verification</h2>
      <p>BallBoy may facilitate but does <strong>not guarantee</strong> identity or background verification.
      You understand that any “Verified” or “Background Checked” badge is based on limited information supplied
      at a specific point in time and is not a substitute for independent due diligence on your part.</p>

      <h2>10. Intellectual Property</h2>
      <p>BallBoy and its logos, trademarks, and content are owned by BallBoy or its licensors. You retain
      ownership of content you upload, but you grant BallBoy a worldwide, royalty-free, transferable license to
      use, display, and distribute such content as necessary to operate and promote the Service.</p>

      <h2>11. DISCLAIMERS</h2>
      <p>THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AVAILABILITY, OR
      ACCURACY. BALLBOY DOES NOT WARRANT THE CONDUCT OF ANY USER OR THE OUTCOME OF ANY BOOKING.</p>

      <h2>12. LIMITATION OF LIABILITY</h2>
      <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, BALLBOY’S TOTAL AGGREGATE LIABILITY ARISING OUT OF OR
      RELATING TO THESE TERMS OR YOUR USE OF THE SERVICE SHALL NOT EXCEED THE GREATER OF (A) ONE HUNDRED US
      DOLLARS (USD $100) OR (B) THE FEES PAID BY YOU TO BALLBOY IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
      IN NO EVENT SHALL BALLBOY BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR
      PUNITIVE DAMAGES, INCLUDING LOSS OF PROFITS, DATA, GOODWILL, OR PERSONAL INJURY, EVEN IF ADVISED OF THE
      POSSIBILITY THEREOF.</p>

      <h2>13. Arbitration &amp; Class Waiver</h2>
      <p>Any dispute arising out of or related to the Service shall be resolved by final and binding arbitration
      administered by the American Arbitration Association under its Commercial Arbitration Rules. The
      arbitration shall take place in Delaware, USA, in English. <strong>You and BallBoy each waive the right
      to a trial by jury and the right to participate in a class, collective, or representative action.</strong>
      Either party may bring claims in small-claims court if they qualify.</p>

      <h2>14. Governing Law</h2>
      <p>These Terms are governed by the laws of the State of Delaware, USA, without regard to its conflict of
      laws rules. Subject to the arbitration clause above, the exclusive forum for any court proceeding shall
      be the state and federal courts of Delaware.</p>

      <h2>15. Modifications</h2>
      <p>BallBoy may modify these Terms at any time by posting an updated version. Continued use after the
      update constitutes acceptance. We will make reasonable effort to notify you of material changes.</p>

      <h2>16. Miscellaneous</h2>
      <p>If any provision is held invalid, the remainder shall continue in full force. Failure to enforce a
      provision is not a waiver. These Terms constitute the entire agreement and supersede any prior
      agreements. You may not assign these Terms without our written consent; we may assign them freely.</p>

      <h2>17. Contact</h2>
      <p>Questions or notices may be sent to <a href="mailto:legal@mail.ballboy.ws">legal@mail.ballboy.ws</a>.</p>

      <p className="mt-8 text-xs text-muted-foreground"><em>This document is provided for operational use and does not
      constitute legal advice. You should have a qualified attorney review and customize this document for your
      jurisdiction and business before relying on it.</em></p>
    </LegalShell>
  );
}
